import React from 'react';
import ModalCloseButton from '../Common/ModalCloseButton';

const AddonModal = ({ show, selectedAddon, onClose }) => {
  if (!show || !selectedAddon) return null;

  return (
    <div className="addon-modal">
      <div className="modal-content">
        <ModalCloseButton onClick={onClose} />
        <div className="modal-image-container">
          <img 
            src={selectedAddon.image} 
            alt={selectedAddon.title}
            className="modal-image"
          />
        </div>
        <div className="modal-details">
          <h3>{selectedAddon.title}</h3>
          <p className="modal-price">${selectedAddon.price}</p>
          <p className="modal-description">{selectedAddon.description}</p>
        </div>
      </div>
    </div>
  );
};

export default AddonModal;
